import script from "./PortalHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./PortalHeader.vue?vue&type=script&setup=true&lang=ts"

import "./PortalHeader.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__